module.exports = __webpack_public_path__ + "img/checked_icon.94ebfbf5.png";